<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <div class="card shadow-sm mb-5 p-5 px-10">
              <h1>{{$t('absences.stat_absences')}}</h1>
              <div class="mt-5">
                <div class="row">
                  <div class="col-md-6 col-lg-4 mb-5" v-for="(stat, key) in statistics" :key="key">
                    <div class="card card-body me-lg-5 shadow">
                      <div class="d-flex flex-stack">
                        <div class="symbol symbol-30px me-4">
                          <div class="symbol-label fs-2 text-white" :class="'bg-'+stat.color">
                            {{stat.count}}
                          </div>
                        </div>
                        <div class="flex-row-fluid flex-wrap">
                          <div class="mb-2">
                            <a class="text-gray-800 fs-6 fw-bolder">
                              {{stat[locale]}}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end py-5">
              <Button type="new" v-if="route.query.viewType === modelViewType.list || !route.query.viewType" @click="changeModelViewType(modelViewType.list)" iconClass="fas fa-list fs-5 me-3" btn-class="btn-sm me-5 fs-5" btn-text="absences.list_view"></Button>
              <OutlineButton type="primary" v-if="route.query.viewType === modelViewType.list || !route.query.viewType" @click="changeModelViewType(modelViewType.calendar)" :border="true" btn-class="btn-sm fs-5" btn-text="absences.calendar_view" iconClass="fas fa-calendar fs-5 me-3" />
              <OutlineButton type="primary" v-if="route.query.viewType === modelViewType.calendar" @click="changeModelViewType(modelViewType.list)" :border="true" btn-class="btn-sm me-5 fs-5" btn-text="absences.list_view" iconClass="fas fa-list fs-5 me-3" />
              <Button type="new" v-if="route.query.viewType === modelViewType.calendar" @click="changeModelViewType(modelViewType.calendar)" iconClass="fas fa-calendar fs-5 me-3" btn-class="btn-sm fs-5" btn-text="absences.calendar_view"></Button>
            </div>

            <div v-if="route.query.viewType === modelViewType.list || !route.query.viewType">
              <ListAbsences @loadStat="loadStatisticQuery"/>
            </div>

            <div v-if="route.query.viewType === modelViewType.calendar">
              <CalendarAbsences />
            </div>

        </template>
    </SubLayout>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import Button from "@/components/Button";
import OutlineButton from "@/components/OutlineButton.vue"
import ListAbsences from "./List"
import {useModelViewType} from "@/composables/modelViewType";
import CalendarAbsences from "./Calendar"

const route = useRoute()
const router = useRouter()

const store = useStore()
const { can } = useHasAbility()
const { locale } = useLocales()

const title = ref("breadcrumbs.absences")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.absences',
    route: 'absences'
  }
])

const { modelViewType } = useModelViewType()
const statistics = ref({})

function changeModelViewType (viewType) {
  router.push({ query: { viewType } });
}

async function loadStatisticQuery() {
  await store.dispatch('absences/getAbsencesStatistics').then((res) => {
    statistics.value = res?.data?.stats
  })
} 

onMounted(async() => {
  loadStatisticQuery()
  await store.dispatch('user/getCurrentUser')
})

</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
